export { default } from '@algonauti/ember-active-storage/services/active-storage';
